import { LoginComponent } from './views/login/login.component';
import { FormEt004Module } from './modules/form-et004.module';
import { FormCd003Module } from './modules/form-cd003.module';
import { FormSec002Module } from './modules/form-sec002.module';
import { FormularioService } from './services/formulario.service';
import { FormQua007Module } from './modules/form-qua007.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormQua042Module } from './modules/form-qua042.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { TopMenuComponent } from './views/top-menu/top-menu.component';
import { AngularmaterialModule } from './modules/angular-material-module';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SharedModule } from './modules/shared.module';
import { LoaderService } from './services/loader.service';
import { LoaderInterceptor } from './services/loader.interceptor';
import { FormRs009Module } from './modules/form-rs009.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormCd001Module } from './modules/form-cd001.module';
import { FormRs005Module } from './modules/form-rs005.module';
import { UploadFileToS3Component } from './views/upload-s3/upload-file-to-s3.component';
import { FormuleConfigModule } from './views/formule-config/formule-config.module';
import { RuleConfigModule } from './views/rule-config/rule-config.module';
import { AdmModule } from './views/adm/adm.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormSequenceManageModule } from './modules/form-sequenceManage.module';
import { LogicSequenceStrategyService } from './services/logic-sequence-strategy.service';
import { LoteDsItemComponent } from './shared/lote-ds-item/lote-ds-item.component';
import { StoreModule } from '@ngrx/store';
import { Sec002Reducer } from './reducer/sec002.reducer';
import { FormMake745Module } from './modules/form-make745.module';
import { FormCamisaTrieurModule } from './modules/form-camisa-trieur-module';

@NgModule({
  declarations: [
    AppComponent,
    TopMenuComponent,
    DashboardComponent,
    LoginComponent,
    UploadFileToS3Component,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AngularmaterialModule,
    SharedModule,
    FormQua007Module,
    FormRs009Module,
    FormSec002Module,
    FormCd001Module,
    FormRs005Module,
    FormCd003Module,
    FormEt004Module,
    FormQua042Module,
    FormMake745Module,
    FormCamisaTrieurModule,
    FormSequenceManageModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    FormuleConfigModule,
    RuleConfigModule,
    AdmModule,
    StoreModule.forRoot(
      {
        sec002: Sec002Reducer
      },
      {
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        }
      }
    )
  ],
  providers: [
    FormularioService,
    LoaderService,
    LogicSequenceStrategyService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
